import React, { useEffect, useState } from 'react';
import { FormControl, FormLabel, Tab, Tabs } from 'react-bootstrap';
import TrelloBoard from '../../components/TrelloBoard';
import LoadingSpinner from '../../components/LoadinSpinner';
import { ConsultaTotvsEmpresa, ConsultaTotvsEmpresaIndividual } from '../../../backend/ConsultaTotvsEmpresa';
import { ErroMsg, SucessoMsg, formatDateColumn, formatValorColumnCard, formatarData } from '../../contents/VariaveisGlobais';
import ConsumoTOTVS_POST from '../../../backend/ConsumoTotvs';
import DisparaEmail from '../../../backend/DisparaEmail';
import PedidoCompraPDF from '../Compras/PedidoCompraPDF';
import ResponsiveDataTable from '../../components/DataTable';
import ConsultaTotvs from '../../../backend/ConsultaTotvs';

import CentralAprovacao from "../../../lib/json/consultas/CentralAprovacao.json"
import CentralAprovacaoSC from "../../../lib/json/consultas/CentralAprovacaoSolCompras.json"
import CentralAprovacaoIS from "../../../lib/json/consultas/CentralAprovacaoSolCompras2.json"
import CentralAprovacaoIC from "../../../lib/json/consultas/CentralAprovacaoContrato.json"
import CentralAprovacaoCT from "../../../lib/json/consultas/CentralAprovacaoContrato2.json"
import CentralAprovacaoIM from "../../../lib/json/consultas/CentralAprovacaoMedicao.json"
import CentralAprovacaoMD from "../../../lib/json/consultas/CentralAprovacaoMedicao2.json"
import CentralAprovacaoBMSI from "../../../lib/json/consultas/CentralAprovacaoBMSI.json"
import CentralAprovacaoBMSIDebito from "../../../lib/json/consultas/CentralAprovacaoBMSIDebito.json"
import CentralAprovacaoPC from "../../../lib/json/consultas/CentralAprovacaoPedido.json"
import CentralAprovacaoAE from "../../../lib/json/consultas/CentralAprovacaoPedido2.json"
import CentralAprovacaoSP from "../../../lib/json/consultas/CentralAprovacaoSolPagamento.json"
import CentralAprovacaoNF from "../../../lib/json/consultas/CentralAprovacaoNotaFiscal.json"
import CentralAprovacaoCP from "../../../lib/json/consultas/CentralAprovacaoContratoParceria.json"
import FilaAprovacao from "../../../lib/json/consultas/FilaAprovacao.json"
import { usePopUp } from '../../components/BootBox';
import { toast } from 'react-toastify';
import { handleCentroCusto, handleCompradorAprovacao, handleCondicaoPagamento, handleContratoMedicaoAprovacao, handleDescricaoMedicaoAprovacao, handleFilialAprovacao, handleFornecedorAprovacao, handleInclusao, handleMemo, handleNumeroAprovacao, handleNumeroContratoAprovacao, handleObservacao, handleOBSMedicao, handlePrioridadeCP, handleProdutoAprovacao, handleProdutoAprovacaoBM, handleProdutoAprovacaoCP, handleSaldoAprovacao, handleSerieAprovacao, handleSituacaoFila, handleTitulo, handleVenctoValor } from '../../components/GridCell/Aprovacao';
import { ConsumoAPI_POST } from '../../../backend/ConsumoAPI';
import { ConsultaAPI_URL } from '../../../backend/ConsultaAPI';
import { ButtonRefresh } from './styles';
import { BiRefresh } from 'react-icons/bi';
import { handleAnexos } from '../../components/GridCell/Solicitacao';
import { handleValorTotal } from '../../components/GridCell/Preco';
import getAnexoFromUrl from '../../../utils/anexoUrl';

function Aprovacoes(){
    const { DisparaBootBox, FechaBootBox  } = usePopUp();
    const [activeTab, setActiveTab] = useState("Solicitacao");
    const [dataAprovacaoSC, setDataAprovacaoSC] = useState([]);
    const [dataAprovacaoCT, setDataAprovacaoCT] = useState([]);
    const [dataAprovacaoMD, setDataAprovacaoMD] = useState([]);
    const [dataAprovacaoBM, setDataAprovacaoBM] = useState([]);
    const [dataAprovacaoPC, setDataAprovacaoPC] = useState([]);
    const [dataAprovacaoSP, setDataAprovacaoSP] = useState([]);
    const [dataAprovacaoNF, setDataAprovacaoNF] = useState([]);
    const [dataAprovacaoCP, setDataAprovacaoCP] = useState([]);
    // const [dataAprovacaoSP, setDataAprovacao] = useState([]);
    const [carregar, setCarregar] = useState(false);
    const usuarioLogado = JSON.parse(localStorage.getItem('usuarioLogado'));
    const empresasAtivas = JSON.parse(localStorage.getItem('empresasOptions')).map( (item) => item.value.substr(0,window._env_?.REACT_APP_TAMANHO_EMPRESA)+'-'+item.value.substr(-window._env_?.REACT_APP_TAMANHO_FILIAL) )

    var aConsultas = [];
    var aSolicitacao = [];
    var aContratos = [];
    var aMedicao = [];
    var aBMSI = [];
    var aPedidos = [];
    var campoMotivo = "";
    var processamentoSolicitacao = 0;
    var processamentoContratos = 0;
    var processamentoMedicao = 0;
    var processamentoBMSI = 0;
    var processamentoPedido = 0;

    const columnsDetalhe = [
        {
            Header: 'Produto',
            accessor: 'PRODUTO',
            render: handleProdutoAprovacao
        }
    ]
    
    const columnsDetalheBM = [
        {
            Header: 'Produto',
            accessor: 'PRODUTO',
            render: handleProdutoAprovacaoBM
        }
    ]
    
    const columnsDetalheCP = [
        {
            Header: 'Produto',
            accessor: 'PRODUTO',
            render: handleProdutoAprovacaoCP
        }
    ]

    const columnsContrato = [
        {
            Header: 'Filial',
            accessor: 'CR_FILIAL',
            render: handleFilialAprovacao
        },
        {
            Header: 'Numero',
            accessor: 'CR_NUM',
            render: handleNumeroContratoAprovacao
        },
        {
            Header: 'Descrição: ',
            accessor: 'OBS'
        },
        {
            Header: 'Fornecedor',
            accessor: 'CODIGO',
            render: handleFornecedorAprovacao
        },
        {
            Header: 'Saldo',
            accessor: 'SALDO',
            render: handleSaldoAprovacao
        },
        {
            Header: 'Cond. Pagto.',
            accessor: 'C7_COND',
            render: handleCondicaoPagamento
        },      
        {
            Header: 'Objeto',
            accessor: 'CN9_CODOBJ',
            render: handleMemo
        }
    ]

    const columnsAprovacaoMD = [
        {
            Header: 'Filial',
            accessor: 'CR_FILIAL',
            render: handleFilialAprovacao
        },
        {
            Header: 'Numero',
            accessor: 'CR_NUM',
            render: handleNumeroAprovacao
        },
        {
            Header: 'Data Inclusão',
            accessor: 'CR_EMISSAO',
            render: handleInclusao
        },
        {
            Header: 'Fornecedor',
            accessor: 'CODIGO',
            render: handleFornecedorAprovacao
        },
        {
            Header: 'Contrato',
            accessor: 'COMPRADOR',
            render: handleContratoMedicaoAprovacao
        },
        {
            Header: 'Usuário',
            accessor: 'CND_USERGI_US',
        },
        {
            Header: 'Descrição',
            accessor: 'OBS',
            render: handleDescricaoMedicaoAprovacao
        },
        {
            Header: 'Valor',
            accessor: 'CR_TOTAL',
            render: formatValorColumnCard
        },
        {
            Header: 'Cond. Pagto.',
            accessor: 'C7_COND',
            render: handleCondicaoPagamento
        },      
        {
            Header: 'Observação',
            accessor: 'OBSMED',
            render: handleOBSMedicao
        }
    ]

    const columnsAprovacao = [
        {
            Header: 'Filial',
            accessor: 'CR_FILIAL',
            render: handleFilialAprovacao
        },
        {
            Header: 'Numero',
            accessor: 'CR_NUM',
            render: handleNumeroAprovacao
        },
        {
            Header: 'Fornecedor',
            accessor: 'CODIGO',
            render: handleFornecedorAprovacao
        },
        {
            Header: 'Comprador',
            accessor: 'NOMECOMPRADOR',
            render: handleCompradorAprovacao
        },
        {
            Header: 'Valor',
            accessor: 'CR_TOTAL',
            render: formatValorColumnCard
        },
        {
            Header: 'Cond. Pagto.',
            accessor: 'C7_COND',
            render: handleCondicaoPagamento
        },        
        {
            Header: 'Obs.',
            accessor: 'OBS',
            render: handleObservacao
        },
        
    ]
    
    const columnsAprovacaoCP = [
        {
            Header: 'Filial',
            accessor: 'CR_FILIAL',
            render: handleFilialAprovacao
        },
        {
            Header: 'Numero',
            accessor: 'CR_NUM',
            render: handleNumeroAprovacao
        },
        {
            Header: 'Fornecedor',
            accessor: 'CODIGO',
            render: handleFornecedorAprovacao
        },
        {
            Header: 'Data Inclusão',
            accessor: 'EMISSAO',
            render: (item) => {
                return (<>
                        <p>
                            <span><strong>Data Inclusão: </strong> {formatarData(item.value)}</span>
                        </p>
                    </>
                )
            }
        },        
        {
            Header: 'Periodo',
            accessor: 'NECESSIDADE',
            render: (item) => {
                const { C3_DATPRI, NECESSIDADE } = item
                return (<>
                        <p>
                            <span className="d-flex justify-content-between">
                                <span><strong>Período Inicio: </strong> {formatarData(C3_DATPRI)}</span>                
                                <span><strong>Fim: </strong> {formatarData(NECESSIDADE)}</span>                
                            </span>
                        </p>
                    </>
                )
            }
        },        
        {
            Header: 'Comprador',
            accessor: 'NOMECOMPRADOR',
            render: handleCompradorAprovacao
        },  
        {
            Header: 'Condição Pagto',
            accessor: 'CONDPG',
            render: handleCondicaoPagamento
        },
        {
            Header: 'Finalidade',
            accessor: 'PRIORIDADE',
            render: (item) => {
                const { TIPOCOMPRA } = item
                return (<>
                        <p>
                            <span className="d-flex justify-content-between">
                                <span><strong>Finalidade: </strong> {TIPOCOMPRA}</span>                
                                <span><strong>Prioridade: </strong> {handlePrioridadeCP(item)}</span>                
                            </span>
                        </p>
                    </>
                )
            }
        },
        {
            Header: 'Anexo',
            accessor: 'ANXCP',
            render: (item, acessor, header) => { const isExpanded = item.isExpanded;
                return isExpanded ? handleAnexos(item, acessor, header) : '';
            }
        },   
    ]

    const columnsAprovacaoBM = [
        {
            Header: 'Filial',
            accessor: 'CR_FILIAL',
            render: handleFilialAprovacao
        },
        {
            Header: 'Numero',
            accessor: 'CR_NUM',
            render: handleNumeroAprovacao
        },
        {
            Header: 'Serviço',
            accessor: 'PRODUTO',
            render: (item) => {
                const { PRODUTO, DESCRICAO } = item
                return (<>
                        <p>
                            <span className="d-flex justify-content-between">
                                <span><strong>Serviço: </strong> {PRODUTO.trim()} - {DESCRICAO.trim()}</span>                
                            </span>
                        </p>
                    </>
                )
            }            
        },
        {
            Header: 'Periodo Inicio',
            accessor: 'NECESSIDADE',
            render: (item) => {
                const { TERMINO, NECESSIDADE } = item
                return (<>
                        <p>
                            <span className="d-flex justify-content-between">
                                <span><strong>Competência Inicio: </strong> {formatarData(NECESSIDADE)}</span>                
                                <span><strong>Fim: </strong> {formatarData(TERMINO)}</span>                
                            </span>
                        </p>
                    </>
                )
            }            
        },        
        {
            Header: 'Centro Custo',
            accessor: 'CC',
            render: (item) => { 
                const { CC, CCDESC } = item;
                return (<>
                        <p>
                            <span className="d-flex justify-content-between">
                                <span><strong>Centro Custo Crédito: </strong> {CC.trim()} - {CCDESC.trim()}</span>                
                            </span>
                        </p>
                    </>
                )
            }
        },
		{
            Header: 'Conta',
            accessor: 'LOCAL',
            render: (item) => { 
                const { LOCAL, NOME } = item;
                return (<>
                        <p>
                            <span className="d-flex justify-content-between">
                                <span><strong>Conta Crédito: </strong> {LOCAL.trim()} - {NOME.trim()}</span>                
                            </span>
                        </p>
                    </>
                )
            }
        },
        {
            Header: 'Anexos',
            accessor: 'PZ2_ANEXOS',
            render: (item, acessor, header) => { 
                const isExpanded = item.isExpanded;
                return isExpanded ? handleAnexos(item, acessor, header) : '';
            }
        },
    ]

    const columnsAprovacaoSP = [ 
        {
            Header: 'Filial',
            accessor: 'CR_FILIAL',
            render: handleFilialAprovacao
        },
        {
            Header: 'Numero',
            accessor: 'CR_NUM',
            render: handleNumeroAprovacao
        },
        {
            Header: 'Fornecedor',
            accessor: 'CODIGO',
            render: handleFornecedorAprovacao
        },
        {
            Header: 'Tp. Sol.',
            accessor: 'DESCRICAO'
        },
        {
            Header: 'Título',
            accessor: 'UM',
            render: handleTitulo
        },
        {
            Header: 'C.Custo',
            accessor: 'CC',
            render: handleCentroCusto
        },
        {
            Header: 'Vencto',
            accessor: 'NECESSIDADE',
            render: handleVenctoValor
        }
    ]

    const columnsAprovacaoNF = [ 
        {
            Header: 'Filial',
            accessor: 'CR_FILIAL',
            render: handleFilialAprovacao
        },
        {
            Header: 'Numero',
            accessor: 'CR_NUM',
            render: handleNumeroAprovacao
        },
        {
            Header: 'Serie',
            accessor: 'SALDO',
            render: handleSerieAprovacao
        },
        {
            Header: 'Fornecedor',
            accessor: 'CODIGO',
            render: handleFornecedorAprovacao
        },
        {
            Header: 'Cond. Pagto',
            accessor: 'CODIGO',
            render: handleCondicaoPagamento
        },
        {
            Header: 'Valor',
            accessor: 'TERMINO',
            render: (item) => { 
                const { NECESSIDADE, TIPOCOMPRA, TERMINO } = item;
                const total = parseFloat(TERMINO, 2) + parseFloat(TIPOCOMPRA, 2) - parseFloat(NECESSIDADE, 2)
                const itemDesc = {value: NECESSIDADE}; 
                const itemFret = {value: TIPOCOMPRA}; 
                const itemNF = {value: total}; 

                return (<>
                    <p>
                        <span className="d-flex justify-content-between">
                            <span><strong>Total Itens: </strong> {handleValorTotal(item)}</span>
                            <span><strong>Desconto: </strong> {handleValorTotal(itemDesc)}</span>                
                        </span>
                    </p>
                    <p>
                        <span className="d-flex justify-content-between">
                            <span><strong>Frete: </strong> {handleValorTotal(itemFret)}</span>
                            <span><strong>Total NF: </strong> {handleValorTotal(itemNF)}</span>                
                        </span>
                    </p>
                </>) 
            }
        },
        {
            Header: 'Usuário',
            accessor: 'LOCAL',
            render: (item) => { return (<p><strong>Usuário:</strong> {item.value.toUpperCase()}</p> ) }
        },
        {
            Header: 'Anexo NF',
            accessor: 'NOMECOMPRADOR',
            render: (item, acessor, header) => { const isExpanded = item.isExpanded;
                return isExpanded ? handleAnexos(item, acessor, header) : '';
            }
        },
    ]

    const columnsFilterBM = [
        {
            Header: 'Filial',
            accessor: 'CR_FILIAL',
        },
        {
            Header: 'Numero',
            accessor: 'NUMERO',
        },
        {
            Header: 'Serviço',
            accessor: 'PRODUTO',
        },        
        {
            Header: 'Centro Custo',
            accessor: 'CC',
        },
		{
            Header: 'Conta',
            accessor: 'LOCAL',
        },
    ]

    const columnsFilter = [
        {
            Header: 'Filial',
            accessor: 'CR_FILIAL',
        },
        {
            Header: 'Numero',
            accessor: 'CR_NUM',
        },
        {
            Header: 'Emissao',
            accessor: 'EMISSAO',
        },
        {
            Header: 'Fornecedor',
            accessor: 'CODIGO',
        },
        {
            Header: 'Nome',
            accessor: 'NOME',
        },
        {
            Header: 'CGC',
            accessor: 'CGC',
        },
        {
            Header: 'Solicitante',
            accessor: 'SOLICITANTE',
        },
        {
            Header: 'Comprador',
            accessor: 'COMPRADOR',
        },
        {
            Header: 'NomeComprador',
            accessor: 'NOMECOMPRADOR',
        },
        {
            Header: 'CodCondPagto',
            accessor: 'CONDPG',
        },
        {
            Header: 'CondicaoPagto',
            accessor: 'E4_DESCRI',
        },
        {
            Header: 'Obs Aux',
            accessor: 'OBSAUX',
        },
        {
            Header: 'Tipo Compra',
            accessor: 'TIPOCOMPRA',
        },
        {
            Header: 'Obs',
            accessor: 'OBS',
        },
        {
            Header: 'Total',
            accessor: 'CR_TOTAL',
        }
    ]

    const handleFilaItem = async(row) => {
        let columnsFilaAprovacao = [
            {
                Header: 'Nivel',
                accessor: 'CR_NIVEL',
            },
            {
                Header: 'Aporovador',
                accessor: 'AK_NOME',
            },
            {
                Header: 'Situacao',
                accessor: 'CR_STATUS',
                Cell: handleSituacaoFila
            },
            {
                Header: 'Data Aprovação',
                accessor: 'CR_DATALIB',
                Cell: formatDateColumn
            },
            {
                Header: 'Aprovado por',
                accessor: 'APROVADOR',
            }
        ]

        let consultaDefault = ''
        if ('BC|BM|BD'.includes(row.CR_TIPO))
            consultaDefault = FilaAprovacao.consulta.replace( "FILTRO", " AND CR_TIPO IN ('BC','BM','BD') AND LEFT(CR_NUM,6) = '" + row.CR_NUM + "' ") + " ORDER BY CR_NIVEL "
        else{
            consultaDefault = FilaAprovacao.consulta.replace( "FILTRO", " AND CR_TIPO = '" + row.CR_TIPO + "' AND CR_NUM = '" + row.CR_NUM + "' ") + " ORDER BY CR_NIVEL "
        }

        let tabelasDefault = FilaAprovacao.tabelas;
        
        let retConsulta = await ConsultaTotvs( consultaDefault, tabelasDefault, row.EMPRESA + row.CR_FILIAL );
        let aDataFilaAprovacao = retConsulta.data;
        
        const Mensagem = ( <>
                <ResponsiveDataTable
                    columns={columnsFilaAprovacao} 
                    data={aDataFilaAprovacao}
                    buttons={[]}
                    habilitaBuscar={false}
                />
            </>
        )
        
        DisparaBootBox('Fila de Aprovação', Mensagem, [{ variant: 'light', action: FechaBootBox, label: '↩ Voltar' }], {}, null, 'xl')

        return false
    }

    const handleAprovarItem = async(row) => {
        let jsonAprova = {
            EMPRESA: row.EMPRESA,
            FILIAL: row.CR_FILIAL,
            TIPOFILA: row.CR_TIPO,
            NUMERO: row.CR_NUM,
            APROVADOR: row.CR_APROV,
            USUARIO: row.CR_USER,
            JUSTIFICATIVA : "",
            TIPO : "A",
        }

        const cPath = row.CR_TIPO === 'IS' ? 'APROVACAOSC' : 'APROVACAO'
        
        let cJSONAprova = JSON.stringify(jsonAprova)
        
        const retornoAprovacao = await ConsumoTOTVS_POST( cPath, cJSONAprova, row.EMPRESA + row.CR_FILIAL )

        if (retornoAprovacao.error !== '00'){
            let cRetorno = retornoAprovacao.CR_NUM || retornoAprovacao.data[0].CR_NUM
            
            ErroMsg('Falha ao Aprovar!\n Erro: \n' + cRetorno);
        }else{
            SucessoMsg("Aprovação realizada com sucesso!");
            atualizaLista(row);
            processaSucessoAprovacao(retornoAprovacao.data[0], row)
        }


        return 
    }

    const processaSucessoAprovacao = async(dataSucesso, rowSucesso) => {
        let dadosEnvio
        let PedidoPDF
        const anexoEmailPC = await getAnexoFromUrl(
            "uploads/email/Novo_Portal_NFs.pdf",
            "Novo Portal de NFS.pdf"
        );

        if (dataSucesso.STATUS === 'L'){
            switch (rowSucesso.TIPODOC) {
                case 'SC':
                    dadosEnvio = {
                        showMsg: true,
                        destinatario: rowSucesso.EMAIL + ( dataSucesso.EMAILCC.trim() ? ';' + dataSucesso.EMAILCC : '' ),
                        assunto: 'Central de Aprovação - Solicitação de Compras',
                        corpo: `<h1>Aviso de Aprovação de Solicitação de Compra</h1>
                                <p>Prezado(a) Usuário(a),</p>
                                <p>Gostaríamos de informar que o registro abaixo foi aprovado com sucesso:</p>
                                <ul>
                                <li><strong>Numéro:</strong> ${rowSucesso.CR_NUM}</li>
                                </ul>
                                <p>Esta ação foi realizada por:</p>
                                <ul>
                                <li><strong>Nome do Aprovador:</strong> ${usuarioLogado.nome}</li>
                                </ul>
                                <p>Agradecemos pela sua colaboração.</p>`,
                    }

                    DisparaEmail(dadosEnvio);

                    break;
                case 'CT':
                    dadosEnvio = {
                        showMsg: true,
                        destinatario: rowSucesso.EMAIL + ( dataSucesso.EMAILCC.trim() ? ';' + dataSucesso.EMAILCC : '' ),
                        assunto: 'Central de Aprovação - Contrato GCT',
                        corpo: `<h1>Aviso de Aprovação de Contrato GCT</h1>
                                <p>Prezado(a) Usuário(a),</p>
                                <p>Gostaríamos de informar que o registro abaixo foi aprovado com sucesso:</p>
                                <ul>
                                <li><strong>Numéro:</strong> ${rowSucesso.CR_NUM}</li>
                                </ul>
                                <p>Esta ação foi realizada por:</p>
                                <ul>
                                <li><strong>Nome do Aprovador:</strong> ${usuarioLogado.nome}</li>
                                </ul>
                                <p>Agradecemos pela sua colaboração.</p>`,
                    }

                    DisparaEmail(dadosEnvio);
                    
                    break;                
                case 'MD':                    
                    if (dataSucesso.PEDIDO && dataSucesso.PEDIDO.length == 6){
                        PedidoPDF = await PedidoCompraPDF( dataSucesso.PEDIDO.trim(), rowSucesso.EMPRESA, rowSucesso.CR_FILIAL)                        
                    }

                    dadosEnvio = {
                        showMsg: true,
                        destinatario: dataSucesso.EMAILCC,
                        assunto: 'Central de Aprovação - Medição de Contrato',
                        corpo: `<h1>Aviso de Aprovação de Medição de Contrato</h1>
                                <p>Prezado(a) Usuário(a),</p>
                                <p>Gostaríamos de informar que o registro abaixo foi aprovado com sucesso:</p>
                                <ul>
                                <li><strong>Numéro:</strong> ${rowSucesso.CR_NUM}</li>
                                </ul>
                                <p>Esta ação foi realizada por:</p>
                                <ul>
                                <li><strong>Nome do Aprovador:</strong> ${usuarioLogado.nome}</li>
                                </ul>
                                ${ dataSucesso.PEDIDO.length != 6 ? '' : '<p>Gerado Pedido de Compra Nº.: ' + dataSucesso.PEDIDO + '</p>' }
                                <p>Agradecemos pela sua colaboração.</p>`
                    }

                    DisparaEmail(dadosEnvio);

                    if (dataSucesso.PEDIDO && dataSucesso.PEDIDO.length == 6){
                        dadosEnvio = {
                            showMsg: true,
                            destinatario: rowSucesso.EMAIL + ( dataSucesso.EMAILCC.trim() ? ';' + dataSucesso.EMAILCC : '' ),
                            assunto: 'Pedido de Compra',
                            corpo: `<p>Prezado(a) ${rowSucesso.NOME},</p>
                            <p>Espero que este e-mail o(a) encontre bem.</p>
                            <p>Gostaríamos de informar que seu pedido de compra, referente ao número ${dataSucesso.PEDIDO.trim()}, foi revisado e aprovado. Agradecemos sua paciência durante o processo de análise.</p>
                            <p>Anexado a este e-mail, por favor, encontra-se o pedido de compra aprovado em formato PDF para sua referência. Por favor, verifique todos os detalhes do pedido, incluindo quantidades, preços e prazos de entrega.</p>
                            <p>Por favor, esteja ciente de que ao proceder com este pedido, você concorda com os termos e condições estabelecidos no documento anexo.</p>
                            <p>Se você tiver alguma dúvida ou precisar de esclarecimentos adicionais, não hesite em entrar em contato conosco. Estamos à disposição para ajudá-lo(a) no que for necessário.</p>
                            <img src="${window._env_?.REACT_APP_URL}:${window._env_?.REACT_APP_PORT}/api/rastreamento/email/pedido?empresa=${rowSucesso.EMPRESA}&filial=${rowSucesso.CR_FILIAL}&pedido=${dataSucesso.PEDIDO.trim()}&status=R" width="1" height="1" />
                            <p>Agradecemos sua cooperação.</p>`,
                            anexos: [ { anexo: PedidoPDF, nome: `Pedido Compra - ${dataSucesso.PEDIDO.trim()}.pdf` },
                                ...(anexoEmailPC?.anexo ? [anexoEmailPC] : [])
                            ],
                        }
                        
                        DisparaEmail(dadosEnvio);
                        ConsultaAPI_URL(`rastreamento/email/pedido?empresa=${rowSucesso.EMPRESA}&filial=${rowSucesso.CR_FILIAL}&pedido=${dataSucesso.PEDIDO.trim()}&status=E`)
                    }
                    
                    break;                
                case 'PC':
                    PedidoPDF = await PedidoCompraPDF( rowSucesso.CR_NUM.trim(), rowSucesso.EMPRESA, rowSucesso.CR_FILIAL)

                    dadosEnvio = {
                        showMsg: true,
                        destinatario: rowSucesso.EMAIL + ( dataSucesso.EMAILCC.trim() ? ';' + dataSucesso.EMAILCC : '' ),
                        assunto: 'Pedido de Compra',
                        corpo: `<p>Prezado(a) ${rowSucesso.NOME},</p>
                        <p>Espero que este e-mail o(a) encontre bem.</p>
                        <p>Gostaríamos de informar que seu pedido de compra, referente ao número ${rowSucesso.CR_NUM.trim()}, foi revisado e aprovado. Agradecemos sua paciência durante o processo de análise.</p>
                        <p>Anexado a este e-mail, por favor, encontra-se o pedido de compra aprovado em formato PDF para sua referência. Por favor, verifique todos os detalhes do pedido, incluindo quantidades, preços e prazos de entrega.</p>
                        <p>Por favor, esteja ciente de que ao proceder com este pedido, você concorda com os termos e condições estabelecidos no documento anexo.</p>
                        <p>Se você tiver alguma dúvida ou precisar de esclarecimentos adicionais, não hesite em entrar em contato conosco. Estamos à disposição para ajudá-lo(a) no que for necessário.</p>
                        <img src="${window._env_?.REACT_APP_URL}:${window._env_?.REACT_APP_PORT}/api/rastreamento/email/pedido?empresa=${rowSucesso.EMPRESA}&filial=${rowSucesso.CR_FILIAL}&pedido=${rowSucesso.CR_NUM.trim()}&status=R" width="1" height="1" />
                        <p>Agradecemos sua cooperação.</p>`,
                        anexos: [ { anexo: PedidoPDF, nome: `Pedido Compra - ${rowSucesso.CR_NUM.trim()}.pdf` }, 
                            ...(anexoEmailPC?.anexo ? [anexoEmailPC] : [])
                        ],
                    }

                    DisparaEmail(dadosEnvio);
                    ConsultaAPI_URL(`rastreamento/email/pedido?empresa=${rowSucesso.EMPRESA}&filial=${rowSucesso.CR_FILIAL}&pedido=${rowSucesso.CR_NUM.trim()}&status=E`)
                    break;
                case 'SP':
                    let cTitulo = dataSucesso.PEDIDO

                    if ( cTitulo === 'FALHA' ){
                        dadosEnvio = {
                            showMsg: true,
                            destinatario: rowSucesso.EMAIL + ( dataSucesso.EMAILCC.trim() ? ';' + dataSucesso.EMAILCC : '' ),
                            assunto: 'Solicitação de Pagamento - Crítica',
                            corpo: `<h1>Solicitação de Pagamento - Crítica Geração de Título</h1>
                                    <p>Prezado(a) Usuário(a),</p>
                                    <p>Identificamos um problema na geração do Título. Isso pode afetar o processamento adequado da transação. Por favor, verifique as informações fornecidas e realize os ajustes necessários. Quaisquer dúvidas ou problemas estamos prontos para ajudá-lo(a) a resolver essa questão.</p>
                                    </br>
                                    <p>Agradecemos pela sua colaboração.</p>`,
                        }
                    }else{
                        dadosEnvio = {
                            showMsg: true,
                            destinatario: rowSucesso.EMAIL + ( dataSucesso.EMAILCC.trim() ? ';' + dataSucesso.EMAILCC : '' ),
                            assunto: 'Central de Aprovação - Solicitação de Pagamento',
                            corpo: `<h1>Aviso de Aprovação de Solicitação de Pagamento</h1>
                                    <p>Prezado(a) Usuário(a),</p>
                                    <p>Gostaríamos de informar que o registro abaixo foi aprovado com sucesso:</p>
                                    <ul>
                                    <li><strong>Numéro:</strong> ${rowSucesso.CR_NUM}</li>
                                    </ul>
                                    <p>Esta ação foi realizada por:</p>
                                    <ul>
                                    <li><strong>Nome do Aprovador:</strong> ${usuarioLogado.nome}</li>
                                    </ul>
                                    ${ dataSucesso.PEDIDO.length = 0 ? '' : '<p>Gerado Título de Pagamento Nº.: ' + dataSucesso.PEDIDO + '</p>' }
                                    <p>Agradecemos pela sua colaboração.</p>`,
                        }
                    }

                    DisparaEmail(dadosEnvio);

                    break;
                default:
                    break;
            }
        }
    }

    const processaSucessoReprovacao = async(dataSucesso, rowSucesso, motivo) => {
        let dadosEnvio
        let cTipo
        let cEmail = dataSucesso.EMAILCC

        switch (rowSucesso.TIPODOC) {
            case 'SC':
                cTipo = "Solicitação de Compra"
                break;

            case 'CT':
                cTipo = "Contrato GCT"
                cEmail = rowSucesso.EMAIL
                break;                
                
            case 'MD':
                cTipo = "Medição de Contrato"
                break;                

            case 'PC':
                cTipo = "Pedido de Compra"
                break;
            
            case 'SP':
                cTipo = "Solicitação de Pagamento"
                break;
            
            case 'CP':
                cTipo = "Contrato Parceria"
                break;

            case 'NF':
                cTipo = "Nota Fiscal - Entrada"
                break;
            
            case 'BM':
                cTipo = "BMSI"
                break;
            
            default:
                break;
        }

        if (cEmail.trim().length > 0){
            switch (rowSucesso.TIPODOC) {
                case 'CT':
                    dadosEnvio = {
                        destinatario: cEmail,
                        assunto: 'Central de Aprovação - ' + cTipo,
                        corpo: `<h1>Aviso de Reprovação de ${cTipo}</h1>
                                <p>Prezado usuário,</p>
                                <p>Gostaríamos de informar que o registro abaixo foi reprovado:</p>
                                <ul>
                                    <li><strong>Contrato:</strong> ${rowSucesso.NUMERO}</li>
                                    <li><strong>Fornecedor:</strong> ${rowSucesso.CODIGO}/${rowSucesso.LOJA} - ${rowSucesso.NOME}</li>
                                </ul>
                                <p>Esta ação foi realizada por:</p>
                                <ul>
                                    <li><strong>Motivo Reprovação:</strong> ${motivo}</li>
                                    <li><strong>Nome do Aprovador:</strong> ${usuarioLogado.nome}</li>
                                </ul>
                                <p>Agradecemos pela sua colaboração.</p>`
                    }
                    break;
                case 'NF':
                    dadosEnvio = {
                        destinatario: cEmail,
                        assunto: 'Central de Aprovação - ' + cTipo,
                        corpo: `<h1>Aviso de Reprovação de ${cTipo}</h1>
                                <p>Prezado usuário,</p>
                                <p>Gostaríamos de informar que o registro abaixo foi reprovado:</p>
                                <ul>
                                    <li><strong>Número:</strong> ${rowSucesso.NUMERO}</li>
                                    <li><strong>Série:</strong> ${rowSucesso.SALDO}</li>
                                    <li><strong>Fornecedor:</strong> ${rowSucesso.CODIGO}/${rowSucesso.LOJA} - ${rowSucesso.NOME}</li>
                                </ul>
                                <p>Esta ação foi realizada por:</p>
                                <ul>
                                    <li><strong>Motivo Reprovação:</strong> ${motivo}</li>
                                    <li><strong>Nome do Aprovador:</strong> ${usuarioLogado.nome}</li>
                                </ul>
                                <p>Agradecemos pela sua colaboração.</p>`
                    }

                    let dadosEnvioTI = { ...dadosEnvio };
                    dadosEnvioTI.destinatario = "rejeicao.nfe.tools@npegroup.com.br"
                    
                    DisparaEmail(dadosEnvioTI);
                    break;
                default:
                    dadosEnvio = {
                        destinatario: cEmail,
                        assunto: 'Central de Aprovação - ' + cTipo,
                        corpo: `<h1>Aviso de Reprovação de ${cTipo}</h1>
                                <p>Prezado usuário,</p>
                                <p>Gostaríamos de informar que o registro abaixo foi reprovado:</p>
                                <ul>
                                    <li><strong>${cTipo}:</strong> ${rowSucesso.NUMERO}</li>
                                    ${rowSucesso.TIPODOC == 'PC' ? '<li><strong>Fornecedor:</strong> ${rowSucesso.CODIGO}/${rowSucesso.LOJA} - ${rowSucesso.NOME}</li>' : ''}
                                </ul>
                                <p>Esta ação foi realizada por:</p>
                                <ul>
                                    <li><strong>Motivo Reprovação:</strong> ${motivo}</li>
                                    <li><strong>Nome do Aprovador:</strong> ${usuarioLogado.nome}</li>
                                </ul>
                                <p>Agradecemos pela sua colaboração.</p>`
                    }                                    
                break;
            }

            DisparaEmail(dadosEnvio);
        }
    }

    const handleReprovarItem = async(row) => {
        const idRow = row.TIPODOC + row.CR_NUM + row.CR_GRUPO;
        const Mensagem = ( <>
                <FormLabel>Motivo Rejeição</FormLabel>
                <FormControl
                    type='text'
                    onChange={handleCampoMotivo}
                />
            </>
        )
        
        const buttonsRender = [
            { variant: 'primary', action: handleConfirmaRejeicao, label: '✓ Confirmar' },
            { variant: 'secondary', action: FechaBootBox, label: '✗ Cancelar' }
        ]
        
        campoMotivo = ''

        DisparaBootBox('Confirma Rejeição ?', Mensagem, buttonsRender, idRow, null)
    }

    const handleCampoMotivo = (e) =>{
        campoMotivo = e.target.value
    }

    const handleConfirmaRejeicao = async(id) =>{
        if (!campoMotivo){
            toast.warning('O prenchimento do Motivo da Rejeição é obrigatório.');
            return
        }
        
        let row
        
        switch ( id.substring(0,2) ) {
            case 'SC':
                row = dataAprovacaoSC.filter((item) => (item.TIPODOC + item.CR_NUM + item.CR_GRUPO === id))[0];
                break;
                
            case 'CT':
                row = dataAprovacaoCT.filter((item) => (item.TIPODOC + item.CR_NUM + item.CR_GRUPO === id))[0];
                break;                
                
            case 'MD':
                row = dataAprovacaoMD.filter((item) => (item.TIPODOC + item.CR_NUM + item.CR_GRUPO === id))[0];
                break;

            case 'PC':
                row = dataAprovacaoPC.filter((item) => (item.TIPODOC + item.CR_NUM + item.CR_GRUPO === id))[0];
                break;

            case 'SP':
                row = dataAprovacaoSP.filter((item) => (item.TIPODOC + item.CR_NUM + item.CR_GRUPO === id))[0];
                break;
            
            case 'CP':
                row = dataAprovacaoCP.filter((item) => (item.TIPODOC + item.CR_NUM + item.CR_GRUPO === id))[0];
                break;

            case 'NF':
                row = dataAprovacaoNF.filter((item) => (item.TIPODOC + item.CR_NUM + item.CR_GRUPO === id))[0];
                break;
            
            case 'BM':
                row = dataAprovacaoBM.filter((item) => (item.TIPODOC + item.CR_NUM + item.CR_GRUPO === id))[0];
                break;

            default:
                break;
        }

        let jsonAprova = {
            EMPRESA: row.EMPRESA,
            FILIAL: row.CR_FILIAL,
            TIPOFILA: row.CR_TIPO,
            NUMERO: row.CR_NUM,
            APROVADOR: row.CR_APROV,
            USUARIO: row.CR_USER,
            JUSTIFICATIVA : campoMotivo,
            TIPO : "R",
        }
        
        let cJSONAprova = JSON.stringify(jsonAprova)
        
        const retornoAprovacao = await ConsumoTOTVS_POST( 'APROVACAO', cJSONAprova, row.EMPRESA + row.CR_FILIAL )

        if (retornoAprovacao.error !== '00'){
            ErroMsg('Falha na Aprovação!\n Erro: \n' + retornoAprovacao.CR_NUM);
        }else{
            SucessoMsg("Reprovação realizada com sucesso!");
            atualizaLista(row);
            processaSucessoReprovacao(retornoAprovacao.data[0], row, campoMotivo)
        }

        FechaBootBox()
    }

    const atualizaLista = (row) => {
        switch (row.TIPODOC) {
            case 'SC':
                let newDataAprovacaoSC = dataAprovacaoSC.filter((item) => (item.CR_NUM + item.CR_GRUPO !== row.CR_NUM + row.CR_GRUPO));
                setDataAprovacaoSC(newDataAprovacaoSC);
                break;

            case 'CT':
                let newDataAprovacaoCT = dataAprovacaoCT.filter((item) => (item.CR_NUM + item.CR_GRUPO !== row.CR_NUM + row.CR_GRUPO));
                setDataAprovacaoCT(newDataAprovacaoCT);
                break;                

            case 'MD':
                let newDataAprovacaoMD = dataAprovacaoMD.filter((item) => (item.CR_NUM + item.CR_GRUPO !== row.CR_NUM + row.CR_GRUPO));
                setDataAprovacaoMD(newDataAprovacaoMD);
                break;                
            
            case 'PC':
                let newDataAprovacao = dataAprovacaoPC.filter((item) => (item.CR_NUM + item.CR_GRUPO !== row.CR_NUM + row.CR_GRUPO));
                setDataAprovacaoPC(newDataAprovacao);
                break;
            
            case 'SP':
                let newDataAprovacaoSP = dataAprovacaoSP.filter((item) => (item.CR_NUM + item.CR_GRUPO !== row.CR_NUM + row.CR_GRUPO));
                setDataAprovacaoSP(newDataAprovacaoSP);
                break;
           
            case 'CP':
                let newDataAprovacaoCP = dataAprovacaoCP.filter((item) => (item.CR_NUM + item.CR_GRUPO !== row.CR_NUM + row.CR_GRUPO));
                setDataAprovacaoCP(newDataAprovacaoCP);
                break;

            case 'NF':
                let newDataAprovacaoNF = dataAprovacaoNF.filter((item) => (item.CR_NUM + item.CR_GRUPO !== row.CR_NUM + row.CR_GRUPO));
                setDataAprovacaoNF(newDataAprovacaoNF);
                break;
            
            case 'BM':
                let newDataAprovacaoBM = dataAprovacaoBM.filter((item) => (item.CR_NUM !== row.CR_NUM && item.CR_GRUPO != row.CR_GRUPO && item.CR_TIPO != row.CR_TIPO));
                setDataAprovacaoBM(newDataAprovacaoBM);
                break;
            
            default:
                break;
        }
    }

    const handleTabSelect = (index) => {
        setActiveTab(index);
    };

    const itensJSONFormatado = (data) => {
        // Objeto para armazenar os itens agrupados por chave
        const itensAgrupados = {};
    
        // Percorre cada item do JSON 1
        data.forEach(item => {
            // Define a chave com base nos campos indicados
            const chave = item.EMPRESA + item.CR_FILIAL + item.CR_NUM + item.CR_GRUPO;
    
            // Verifica se a chave já existe no objeto de itens agrupados
            if (!itensAgrupados[chave]) {
                // Se não existir, cria um novo objeto para essa chave
                itensAgrupados[chave] = {
                    ...item, // Copia todos os campos do item
                    ITENS: [] // Inicializa a lista de itens vazia
                };
            }
    
            // Adiciona o item atual à lista de itens do comprador correspondente
            itensAgrupados[chave].ITENS.push({
                // Mapeia apenas os campos específicos dos itens
                FILIAL: item.FILIAL,
                NUMERO: item.NUMERO,
                ITEM: item.ITEM,
                PRODUTO: item.PRODUTO,
                DESCRICAO: item.DESCRICAO,
                UM: item.UM,
                QUANT: item.QUANT,
                PRECO: item.PRECO,
                TOTAL: item.TOTAL,
                CC: item.CC,
                CCDESC: item.CCDESC,
                LOCAL: item.LOCAL,
                EMISSAO: item.EMISSAO,
                NECESSIDADE: item.NECESSIDADE,
                NUMSC: item.NUMSC,
                ITEMSC: item.ITEMSC,
                SOLICITANTE: item.SOLICITANTE,
                CONDPG: item.CONDPG,
                OBS: item.OBS,
                OBSAUX: item.OBSAUX
            });
        });
    
        // Retorna os valores dos itens agrupados como um array
        return removerDuplicidadeItens(Object.values(itensAgrupados));
    }

    function removerDuplicidadeItens(arrayPrincipal) {
        return arrayPrincipal.map(obj => {
            const map = new Map();

            obj.ITENS.forEach(item => {
                const chave = `${item.NUMERO}_${item.ITEM}`;
                if (!map.has(chave)) {
                    map.set(chave, item);
                }
            });

            return {
                ...obj,
                ITENS: Array.from(map.values())
            };
        });
    }

    const listaAprovacoes = async () => {
        setCarregar(true)
        aConsultas = []
        aSolicitacao = []
        aContratos = []
        aMedicao = []
        aBMSI = []
        aPedidos = []

        let consultaAprovacao = CentralAprovacao.consulta;
        let tabelasAprovacao = CentralAprovacao.tabelas;        
        let empresaFilial = localStorage.getItem('empresaFilial').substr(0,window._env_?.REACT_APP_TAMANHO_EMPRESA) + '-' + localStorage.getItem('empresaFilial').substr(2,6);
        processaConsulta(consultaAprovacao, tabelasAprovacao, empresaFilial, processaCentralAprovacao, false)
    }
    
    const processaCentralAprovacao = (dadosFiliais) =>{
        let empresasSC = []
        let empresasPC = []
        let empresasCT = []
        let empresasMD = []
        let empresasBM = []
        let empresasSP = []
        let empresasNF = []
        let empresasCP = []
        
        dadosFiliais.forEach((row) => {
            switch (row.TIPO) {
                case 'SC':
                    empresasSC.push( row.EMPRESA + "-" + row.CR_FILIAL )
                    break;
                case 'PC':
                    empresasPC.push( row.EMPRESA + "-" + row.CR_FILIAL )
                    break;
                case 'CT':
                    empresasCT.push( row.EMPRESA + "-" + row.CR_FILIAL )
                    break;
                case 'MD':
                    empresasMD.push( row.EMPRESA + "-" + row.CR_FILIAL )
                    break;
                case 'SP':
                    empresasSP.push( row.EMPRESA + "-" + row.CR_FILIAL )
                    break;
                case 'CP':
                    empresasCP.push( row.EMPRESA + "-" + row.CR_FILIAL )
                    break;
                case 'NF':
                    empresasNF.push( row.EMPRESA + "-" + row.CR_FILIAL )
                    break;
                case 'BM':
                    empresasBM.push( row.EMPRESA + "-" + row.CR_FILIAL )
                    break;
                default:
                    break;
            }
        })

        processamentoSolicitacao = 0
        processamentoContratos = 0
        processamentoMedicao = 0
        processamentoBMSI = 0
        processamentoPedido = 0

        consultaSolicitacoesCompra(empresasSC)
        consultaSolicitacoesPagamento(empresasSP)
        consultaNotaFiscal(empresasNF)
        consultaContratoParceria(empresasCP)
        consultaPedidosCompra(empresasPC)
        consultaContratos(empresasCT)
        consultaMedicoes(empresasMD)
        consultaBMSI(empresasBM)

        if (aConsultas.length >= 12){
            setCarregar(false)
        }
    }

    const consultaSolicitacoesCompra = (empresasSC) => {
        let consultaDefault = CentralAprovacaoSC.consulta
        let tabelasDefault = CentralAprovacaoSC.tabelas;
        processaConsultaIndividual(consultaDefault, tabelasDefault, empresasSC.join(';'), processaSC)

        consultaDefault = CentralAprovacaoIS.consulta
        tabelasDefault = CentralAprovacaoIS.tabelas;
        processaConsultaGoEvo(consultaDefault, tabelasDefault, empresasSC.join(';'), processaSC)
    }

    const consultaPedidosCompra = (empresasPC) => {
        if (empresasPC.length > 0){
            let consultaDefault = CentralAprovacaoPC.consulta
            let tabelasDefault = CentralAprovacaoPC.tabelas;
            processaConsultaIndividual(consultaDefault, tabelasDefault, empresasPC.join(';'), processaPedidos)
            
            consultaDefault = CentralAprovacaoAE.consulta
            tabelasDefault = CentralAprovacaoAE.tabelas;
            processaConsulta(consultaDefault, tabelasDefault, empresasPC.join(';'), processaPedidos)
        }else{
            aConsultas.push('PC 1')
            aConsultas.push('PC 2')
        }
    }

    const consultaContratos = (empresasCT) => {
        if (empresasCT.length > 0){
            let consultaDefault = CentralAprovacaoIC.consulta
            let tabelasDefault = CentralAprovacaoIC.tabelas;
            processaConsultaIndividual(consultaDefault, tabelasDefault, empresasCT.join(';'), processaContratos)

            consultaDefault = CentralAprovacaoCT.consulta
            tabelasDefault = CentralAprovacaoCT.tabelas;
            processaConsultaIndividual(consultaDefault, tabelasDefault, empresasCT.join(';'), processaContratos)
        }else{
            aConsultas.push('CT 1')
            aConsultas.push('CT 2')
        }
    }

    const consultaMedicoes = (empresasMD) => {
        if (empresasMD.length > 0){
            let consultaDefault = CentralAprovacaoIM.consulta
            let tabelasDefault = CentralAprovacaoIM.tabelas;
            processaConsultaIndividual(consultaDefault, tabelasDefault, empresasMD.join(';'), processaMedicao)
            
            consultaDefault = CentralAprovacaoMD.consulta
            tabelasDefault = CentralAprovacaoMD.tabelas;
            processaConsultaIndividual(consultaDefault, tabelasDefault, empresasMD.join(';'), processaMedicao)
        }else{
            aConsultas.push('MD 1')
            aConsultas.push('MD 2')            
        }
    }
    
    const consultaBMSI = (empresasBM) => {
        if (empresasBM.length > 0){
            let consultaDefault = CentralAprovacaoBMSI.consulta
            let tabelasDefault = CentralAprovacaoBMSI.tabelas;
            processaConsultaIndividual(consultaDefault, tabelasDefault, empresasBM.join(';'), processaBMSI)
            
            consultaDefault = CentralAprovacaoBMSIDebito.consulta
            tabelasDefault = CentralAprovacaoBMSIDebito.tabelas;
            processaConsultaIndividual(consultaDefault, tabelasDefault, empresasBM.join(';'), processaBMSI)
        }else{
            aConsultas.push('BM 1')
            aConsultas.push('BM 2')            
        }
    }

    const consultaSolicitacoesPagamento = (empresasSP) => {
        if (empresasSP.length > 0){
            let consultaDefault = CentralAprovacaoSP.consulta
            let tabelasDefault = CentralAprovacaoSP.tabelas;
            processaConsulta(consultaDefault, tabelasDefault, empresasSP.join(';'), processaSP)
        }else{
            aConsultas.push('SP')
        }
    }
    
    const consultaContratoParceria = (empresasCP) => {
        if (empresasCP.length > 0){
            let consultaDefault = CentralAprovacaoCP.consulta
            let tabelasDefault = CentralAprovacaoCP.tabelas;
            processaConsultaIndividual(consultaDefault, tabelasDefault, empresasCP.join(';'), processaCP)
        }else{
            aConsultas.push('CP')
        }
    }

    const consultaNotaFiscal = (empresasNF) => {
        if (empresasNF.length > 0){
            let consultaDefault = CentralAprovacaoNF.consulta
            let tabelasDefault = CentralAprovacaoNF.tabelas;
            processaConsultaIndividual(consultaDefault, tabelasDefault, empresasNF.join(';'), processaNF)
        }else{
            aConsultas.push('NF')
        }
    }

    const processaSC = (dadosSC) =>{
        processamentoSolicitacao++
        
        if (dadosSC){
            aSolicitacao.push(...dadosSC);
        }
        
        if (processamentoSolicitacao === 2){
            aConsultas.push('SC 1')
            aConsultas.push('SC 2')
            aSolicitacao.sort((a, b) => a.EMISSAO.localeCompare(b.EMISSAO));

            setDataAprovacaoSC(aSolicitacao);
        }   
    }

    const processaSP = (dadosSP) =>{
        aConsultas.push('SP')
        setDataAprovacaoSP(dadosSP)
    }

    const processaNF = (dadosNF) =>{
        aConsultas.push('NF')
        setDataAprovacaoNF(dadosNF)
    }

    const processaContratos = (dadosContrato) =>{
        processamentoContratos++
        
        if (dadosContrato){
            aContratos.push(...dadosContrato);
        }
        
        if (processamentoContratos === 2){
            aConsultas.push('CT 1')
            aConsultas.push('CT 2')
            setDataAprovacaoCT(aContratos);
        }        
    }

    const processaCP = (dadosCP) =>{
        aConsultas.push('CP')
        setDataAprovacaoCP(dadosCP);
    }

    const processaPedidos = (dadosPedidos) =>{
        processamentoPedido++
        
        if (dadosPedidos){
            aPedidos.push(...dadosPedidos);
        }
        
        if (processamentoPedido === 2){
            aConsultas.push('PC 1')
            aConsultas.push('PC 2')
            aPedidos.sort((a, b) => a.EMISSAO.localeCompare(b.EMISSAO));

            setDataAprovacaoPC(aPedidos);
        }
    }

    const processaMedicao = (dadosMedicao) =>{
        processamentoMedicao++
        
        if (dadosMedicao){
            aMedicao.push(...dadosMedicao);
        }
        
        if (processamentoMedicao === 2){
            aConsultas.push('MD 1')
            aConsultas.push('MD 2')
            aMedicao.sort((a, b) => a.CR_EMISSAO.localeCompare(b.CR_EMISSAO));
            setDataAprovacaoMD(aMedicao);
        }
    }

    const processaBMSI = (dadosBMSI) =>{
        processamentoBMSI++
        
        if (dadosBMSI){
            aBMSI.push(...dadosBMSI);
        }
        
        if (processamentoBMSI === 2){
            aConsultas.push('BM 1')
            aConsultas.push('BM 2')
            aBMSI.sort((a, b) => a.EMISSAO.localeCompare(b.EMISSAO));

            setDataAprovacaoBM(aBMSI);
        }
    }
    
    const processaConsultaGoEvo = async(consultaDefault, tabelasDefault, cEmpresas, returnFunction, formataRetorno = true) => {
        consultaDefault = consultaDefault.replaceAll('FILTRO', " AND UPPER(ZT1_EMAIL) = '" + usuarioLogado.email + "'")
        
        let retConsulta = await ConsultaTotvsEmpresaIndividual( consultaDefault, tabelasDefault, cEmpresas );
        if (formataRetorno){
            let aDataRetorno = retConsulta.data.map((item) => { item.item = item.CR_NUM; return item});
            let aDataAprova = itensJSONFormatado(aDataRetorno);
            aDataAprova = aDataAprova.map((item) => { item.item = item.CR_NUM + item.CR_GRUPO; return item});
            
            retornoConsulta(aDataAprova, returnFunction)
        }else{
            retornoConsulta(retConsulta.data, returnFunction)
        }
    }

    const processaConsulta = async(consultaDefault, tabelasDefault, cEmpresas, returnFunction, formataRetorno = true) => {
        const usuarioProtheus = JSON.parse(usuarioLogado.usuarioProtheus).value;
        consultaDefault = consultaDefault.replaceAll('FILTRO', " AND AK_USER = '" + usuarioProtheus + "' ")
        
        let retConsulta = await ConsultaTotvsEmpresa( consultaDefault, tabelasDefault, cEmpresas );
        if (formataRetorno){
            let aDataRetorno = retConsulta.data.map((item) => { item.item = item.CR_NUM; return item});
            let aDataAprova = itensJSONFormatado(aDataRetorno);
            aDataAprova = aDataAprova.map((item) => { item.item = item.CR_NUM + item.CR_GRUPO; return item});
            
            retornoConsulta(aDataAprova, returnFunction)
        }else{
            retornoConsulta(retConsulta.data, returnFunction)
        }
    }

    const processaConsultaIndividual = async(consultaDefault, tabelasDefault, cEmpresas, returnFunction) => {
        const usuarioProtheus = JSON.parse(usuarioLogado.usuarioProtheus).value;
        consultaDefault = consultaDefault.replaceAll('FILTRO', " AND AK_USER = '" + usuarioProtheus + "' ")
        
        let retConsulta = await ConsultaTotvsEmpresaIndividual( consultaDefault, tabelasDefault, cEmpresas );
        let aDataRetorno = retConsulta.data;
        let aDataAprova = itensJSONFormatado(aDataRetorno);
        aDataAprova = aDataAprova.map((item) => { item.item = item.CR_NUM + item.CR_GRUPO + item.CR_ITGRP; return item});

        retornoConsulta(aDataAprova, returnFunction)
    }

    const retornoConsulta = (aDataAprova, returnFunction) => {
        returnFunction(aDataAprova);
        
        if (aConsultas.length >= 10){
            setCarregar(false)
        }
    }

    useEffect( () => {
        listaAprovacoes()
    },[])

    const handleAprovarTodos = (tipo) => {
        let dataEvento
        switch ( tipo ) {
            case 'SC':
                dataEvento = dataAprovacaoSC.filter((item) => item.isSelected === true)      
                break;
                
            case 'CT':
                dataEvento = dataAprovacaoCT.filter((item) => item.isSelected === true)      
                break;                
                
            case 'MD':
                dataEvento = dataAprovacaoMD.filter((item) => item.isSelected === true)      
                break;

            case 'PC':
                dataEvento = dataAprovacaoPC.filter((item) => item.isSelected === true)      
                break;

            case 'SP':
                dataEvento = dataAprovacaoSP.filter((item) => item.isSelected === true)      
                break;
            
            case 'CP':
                dataEvento = dataAprovacaoCP.filter((item) => item.isSelected === true)      
                break;

            case 'NF':
                dataEvento = dataAprovacaoNF.filter((item) => item.isSelected === true)      
                break;
            
            case 'BM':
                dataEvento = dataAprovacaoBM.filter((item) => item.isSelected === true)      
                break;

            default:
                break;
        }

        processaAprovarTodos(tipo, dataEvento) 
    }

    const handleReprovarTodos = (tipo) => {
        const idRow = tipo;
        const Mensagem = ( <>
                <FormLabel>Motivo Rejeição</FormLabel>
                <FormControl
                    type='text'
                    onChange={handleCampoMotivo}
                />
            </>
        )
        
        const buttonsRender = [
            { variant: 'primary', action: processaReprovarTodos, label: '✓ Confirmar' },
            { variant: 'secondary', action: FechaBootBox, label: '✗ Cancelar' }
        ]
        
        campoMotivo = ''

        DisparaBootBox('Confirma Rejeição ?', Mensagem, buttonsRender, idRow, null)
    }

    const processaAprovarTodos = async( tipo, dataEvento ) => {
        setCarregar(true)
        const empresaFilial = dataEvento[0].EMPRESA + dataEvento[0].CR_FILIAL
        const jsonAprova = dataEvento.map((row) => {
            let jsonMap = {
                EMPRESA: row.EMPRESA,
                FILIAL: row.CR_FILIAL,
                TIPOFILA: row.CR_TIPO,
                NUMERO: row.CR_NUM,
                APROVADOR: row.CR_APROV,
                USUARIO: row.CR_USER,
                JUSTIFICATIVA : "",
                TIPO : "A",
                ROWORIGEM: row
            }

            return jsonMap
        })
        
        const cJSONAprova = JSON.stringify(jsonAprova)            
    
        const retornoAprovacao = await ConsumoTOTVS_POST( 'LOTEAPROVACAO', cJSONAprova, empresaFilial )

        if (retornoAprovacao){
            const dataRetorno = retornoAprovacao.data

            dataRetorno.forEach((item) => {
                const rowOrigem = JSON.parse(item.ORIGEM);

                if (item.error !== '00'){
                    ErroMsg('Falha no processo de Aprovação do Registro(' + rowOrigem.CR_TIPO + ' - ' + rowOrigem.CR_NUM + ')\n Erro: \n' + item.CR_NUM);
                }else{
                    SucessoMsg("Aprovação realizada com sucesso!");
                    // atualizaLista(rowOrigem);
                    processaSucessoAprovacao(item, rowOrigem);
                }

            })

            atualizaListaTodos(tipo, dataRetorno)
        }

        setCarregar(false)
    }

    const processaReprovarTodos = async(tipo) =>{
        if (!campoMotivo){
            toast.warning('O prenchimento do Motivo da Rejeição é obrigatório.');
            return
        }

        FechaBootBox()
        setCarregar(true)
        
        let dataEvento
        
        switch ( tipo ) {
            case 'SC':
                dataEvento = dataAprovacaoSC.filter((item) => item.isSelected === true)      
                break;
                
            case 'CT':
                dataEvento = dataAprovacaoCT.filter((item) => item.isSelected === true)      
                break;                
                
            case 'MD':
                dataEvento = dataAprovacaoMD.filter((item) => item.isSelected === true)      
                break;

            case 'PC':
                dataEvento = dataAprovacaoPC.filter((item) => item.isSelected === true)      
                break;

            case 'SP':
                dataEvento = dataAprovacaoSP.filter((item) => item.isSelected === true)      
                break;
            
            case 'CP':
                dataEvento = dataAprovacaoCP.filter((item) => item.isSelected === true)      
                break;

            case 'NF':
                dataEvento = dataAprovacaoNF.filter((item) => item.isSelected === true)      
                break;
            
            case 'BM':
                dataEvento = dataAprovacaoBM.filter((item) => item.isSelected === true)      
                break;

            default:
                break;
        }

        const empresaFilial = dataEvento[0].EMPRESA + dataEvento[0].CR_FILIAL
        const jsonAprova = dataEvento.map((row) => {
            let jsonMap = {
                EMPRESA: row.EMPRESA,
                FILIAL: row.CR_FILIAL,
                TIPOFILA: row.CR_TIPO,
                NUMERO: row.CR_NUM,
                APROVADOR: row.CR_APROV,
                USUARIO: row.CR_USER,
                JUSTIFICATIVA : campoMotivo,
                TIPO : "R",
                ROWORIGEM: row
            }

            return jsonMap
        })
        
        const cJSONAprova = JSON.stringify(jsonAprova)            
    
        const retornoAprovacao = await ConsumoTOTVS_POST( 'LOTEAPROVACAO', cJSONAprova, empresaFilial )

        if (retornoAprovacao){
            const dataRetorno = retornoAprovacao.data

            dataRetorno.forEach((item) => {
                const rowOrigem = JSON.parse(item.ORIGEM);

                if (item.error !== '00'){
                    ErroMsg('Falha no processo de Aprovação do Registro(' + rowOrigem.CR_TIPO + ' - ' + rowOrigem.CR_NUM + ')\n Erro: \n' + item.CR_NUM);
                }else{
                    SucessoMsg("Reprovação realizada com sucesso!");
                    processaSucessoReprovacao(item, rowOrigem, campoMotivo);
                }

            })
            
            atualizaListaTodos(tipo, dataRetorno)
        }

        setCarregar(false)
    }

    const atualizaListaTodos = (tipo, dataRetorno) => {
        const dataSucesso = dataRetorno.filter( item => item.error === '00' ).map(itemEvento => {
            itemEvento.ORIGEM = JSON.parse(itemEvento.ORIGEM)
            return itemEvento
        })

        if (dataSucesso){
            let  dataEvento
                
            switch ( tipo ) {
                case 'SC':
                    dataEvento = dataAprovacaoSC
                    break;
                    
                case 'CT':
                    dataEvento = dataAprovacaoCT
                    break;                
                    
                case 'MD':
                    dataEvento = dataAprovacaoMD
                    break;

                case 'PC':
                    dataEvento = dataAprovacaoPC
                    break;

                case 'SP':
                    dataEvento = dataAprovacaoSP
                    break;

                case 'CP':
                    dataEvento = dataAprovacaoCP
                    break;

                case 'NF':
                    dataEvento = dataAprovacaoNF
                    break;
                
                case 'BM':
                    dataEvento = dataAprovacaoBM
                    break;

                default:
                    break;
            }

            let newDataAprovacao = dataEvento.filter(itemAprovacao =>
                !dataSucesso.some(itemEvento =>
                    itemEvento.ORIGEM.CR_NUM === itemAprovacao.CR_NUM &&
                    itemEvento.ORIGEM.CR_GRUPO === itemAprovacao.CR_GRUPO
                )
            );

            switch ( tipo ) {
                case 'SC':
                    setDataAprovacaoSC(newDataAprovacao)
                    break;
                case 'CT':
                    setDataAprovacaoCT(newDataAprovacao)
                    break;                
                case 'MD':
                    setDataAprovacaoMD(newDataAprovacao)
                    break;
                case 'PC':
                    setDataAprovacaoPC(newDataAprovacao)
                    break;
                case 'SP':
                    setDataAprovacaoSP(newDataAprovacao)
                    break;
                case 'CP':
                    setDataAprovacaoCP(newDataAprovacao)
                    break;
                case 'NF':
                    setDataAprovacaoNF(newDataAprovacao)
                    break;
                case 'BM':
                    setDataAprovacaoBM(newDataAprovacao)
                    break;
                default:
                    break;
            }
        }
    }

    return (
        <>
            <LoadingSpinner isLoading={carregar}/>
            <div style={{ position: 'relative' }}>
                <Tabs activeKey={activeTab} onSelect={handleTabSelect} id="tab-panel" >
                    { dataAprovacaoSC && dataAprovacaoSC.length > 0 && (
                        <Tab key={"Solicitacao"} eventKey={"Solicitacao"} title={`Solicitação de Compra - ${dataAprovacaoSC.length}`}>
                            <div className="tab-content">
                                <TrelloBoard
                                    columnsFilter={columnsFilter}
                                    AbreBox={DisparaBootBox}
                                    FechaBox={FechaBootBox}
                                    columns={columnsAprovacao.filter((item) => item.Header !== 'Fornecedor' && item.Header !== 'Cond. Pagto.')} 
                                    data={dataAprovacaoSC}
                                    setData={setDataAprovacaoSC}
                                    tamanhoCard='60lvh'
                                    titleLista={`Solicitação de Compras`}
                                    columnsAditional={columnsDetalhe}
                                    HabilitaSelecao={true}
                                    mdColCard={4}
                                    exibeList={false}
                                    mdColCardOpen={12}
                                    buttons= { 
                                            [   {action: handleFilaItem, label: "Fila", icone: "FaListCheck", style: "outline-info"},
                                                {action: handleAprovarItem, label: "Aprovar", icone: "AiOutlineLike", style: "outline-success"},
                                                {action: handleReprovarItem, label: "Reprovar", icone: "AiOutlineDislike", style: "outline-danger" }
                                            ]
                                    }
                                    handleAprovarTodos={() => handleAprovarTodos('SC')}
                                    handleReprovarTodos={() => handleReprovarTodos('SC')}
                                    HabilitaBuscar={true}
                                />
                            </div>
                        </Tab>
                    )}
                    { dataAprovacaoPC && dataAprovacaoPC.length > 0 && (
                        <Tab key={"Pedido"} eventKey={"Pedido"} title={`Pedido de Compra - ${dataAprovacaoPC.length}`} >
                            <div className="tab-content">
                                <TrelloBoard
                                    columnsFilter={columnsFilter}
                                    AbreBox={DisparaBootBox}
                                    FechaBox={FechaBootBox}
                                    columns={columnsAprovacao} 
                                    data={dataAprovacaoPC} 
                                    setData={setDataAprovacaoPC} 
                                    tamanhoCard='70lvh'
                                    titleLista={`Pedido Compra`}
                                    columnsAditional={columnsDetalhe}
                                    mdColCard={4}
                                    exibeList={false}
                                    mdColCardOpen={12}
                                    HabilitaSelecao={true}
                                    buttons= { 
                                            [   {action: handleFilaItem, label: "Fila", icone: "FaListCheck", style: "outline-info"},
                                                {action: handleAprovarItem, label: "Aprovar", icone: "AiOutlineLike", style: "outline-success"},
                                                {action: handleReprovarItem, label: "Reprovar", icone: "AiOutlineDislike", style: "outline-danger" }
                                            ]
                                    }
                                    handleAprovarTodos={() => handleAprovarTodos('PC')}
                                    handleReprovarTodos={() => handleReprovarTodos('PC')}
                                    HabilitaBuscar={true}
                                />
                            </div>
                        </Tab>
                    )}
                    { dataAprovacaoCT && dataAprovacaoCT.length > 0 && (
                        <Tab key={"Contrato"} eventKey={"Contrato"} title={`Contrato GCT - ${dataAprovacaoCT.length}`}>
                            <div className="tab-content">
                                <TrelloBoard
                                    columnsFilter={columnsFilter}
                                    AbreBox={DisparaBootBox}
                                    FechaBox={FechaBootBox}
                                    tamanhoCard='70lvh'
                                    columns={columnsContrato} 
                                    data={dataAprovacaoCT} 
                                    setData={setDataAprovacaoCT} 
                                    titleLista={`Contrato`}
                                    columnsAditional={columnsDetalhe}
                                    HabilitaSelecao={true}
                                    mdColCard={4}
                                    exibeList={false}
                                    mdColCardOpen={12}
                                    buttons= { 
                                            [   {action: handleFilaItem, label: "Fila", icone: "FaListCheck", style: "outline-info"},
                                                {action: handleAprovarItem, label: "Aprovar", icone: "AiOutlineLike", style: "outline-success"},
                                                {action: handleReprovarItem, label: "Reprovar", icone: "AiOutlineDislike", style: "outline-danger" }
                                            ]
                                    }
                                    handleAprovarTodos={() => handleAprovarTodos('CT')}
                                    handleReprovarTodos={() => handleReprovarTodos('CT')}
                                    HabilitaBuscar={true}
                                />
                            </div>
                        </Tab>
                    )}
                    { dataAprovacaoMD && dataAprovacaoMD.length > 0 && (
                        <Tab key={"Medicao"} eventKey={"Medicao"} title={`Medição de Contrato - ${dataAprovacaoMD.length}`}>
                            <div className="tab-content">
                                <TrelloBoard
                                    columnsFilter={columnsFilter}
                                    AbreBox={DisparaBootBox}
                                    FechaBox={FechaBootBox}
                                    columns={columnsAprovacaoMD} 
                                    tamanhoCard='85lvh'
                                    data={dataAprovacaoMD} 
                                    setData={setDataAprovacaoMD} 
                                    titleLista={`Medição de Contrato`}
                                    columnsAditional={columnsDetalhe}
                                    mdColCard={4}
                                    exibeList={false}
                                    mdColCardOpen={12}
                                    HabilitaSelecao={true}
                                    buttons= { 
                                            [   {action: handleFilaItem, label: "Fila", icone: "FaListCheck", style: "outline-info"},
                                                {action: handleAprovarItem, label: "Aprovar", icone: "AiOutlineLike", style: "outline-success"},
                                                {action: handleReprovarItem, label: "Reprovar", icone: "AiOutlineDislike", style: "outline-danger" }
                                            ]
                                    }
                                    handleAprovarTodos={() => handleAprovarTodos('MD')}
                                    handleReprovarTodos={(e) => handleReprovarTodos('MD')}
                                    HabilitaBuscar={true}
                                />
                            </div>
                        </Tab>
                    )}
                    { dataAprovacaoSP && dataAprovacaoSP.length > 0 && (
                        <Tab key={"SolicitacaoPagamento"} eventKey={"SolicitacaoPagamento"} title={`Solicitação de Pagamento -  ${dataAprovacaoSP.length}`}>
                            <div className="tab-content">
                                <TrelloBoard
                                    columnsFilter={columnsFilter}
                                    AbreBox={DisparaBootBox}
                                    FechaBox={FechaBootBox}
                                    columns={columnsAprovacaoSP}
                                    data={dataAprovacaoSP}
                                    setData={setDataAprovacaoSP}
                                    titleLista={`Solicitação Pagamento`}
                                    exibeList={false}
                                    tamanhoCard='80lvh'
                                    mdColCard={4}
                                    mdColCardOpen={12}
                                    HabilitaSelecao={true}
                                    buttons= { 
                                            [   {action: handleFilaItem, label: "Fila", icone: "FaListCheck", style: "outline-info"},
                                                {action: handleAprovarItem, label: "Aprovar", icone: "AiOutlineLike", style: "outline-success"},
                                                {action: handleReprovarItem, label: "Reprovar", icone: "AiOutlineDislike", style: "outline-danger" }
                                            ]
                                    }
                                    handleAprovarTodos={() => handleAprovarTodos('SP')}
                                    handleReprovarTodos={() => handleReprovarTodos('SP')}
                                    HabilitaBuscar={true}
                                />
                            </div>
                        </Tab>
                    )}
                    { dataAprovacaoNF && dataAprovacaoNF.length > 0 && (
                        <Tab key={"NF"} eventKey={"NF"} title={`Nota Fiscal de Entrada - ${dataAprovacaoNF.length}`}>
                            <div className="tab-content">
                                <TrelloBoard
                                    columnsFilter={columnsFilter.filter((item) => item.Header !== 'Emissao')}
                                    AbreBox={DisparaBootBox}
                                    FechaBox={FechaBootBox}
                                    columns={columnsAprovacaoNF}                                    
                                    columnsAditional={columnsDetalhe}
                                    data={dataAprovacaoNF}
                                    setData={setDataAprovacaoNF}
                                    titleLista={`Nota Fiscal de Entrada`}
                                    mdColCard={4}
                                    exibeList={false}
                                    mdColCardOpen={12}
                                    tamanhoCard='95lvh'
                                    HabilitaSelecao={true}
                                    buttons= { 
                                            [   {action: handleFilaItem, label: "Fila", icone: "FaListCheck", style: "outline-info"},
                                                {action: handleAprovarItem, label: "Aprovar", icone: "AiOutlineLike", style: "outline-success"},
                                                {action: handleReprovarItem, label: "Reprovar", icone: "AiOutlineDislike", style: "outline-danger" }
                                            ]
                                    }
                                    handleAprovarTodos={() => handleAprovarTodos('NF')}
                                    handleReprovarTodos={() => handleReprovarTodos('NF')}
                                    HabilitaBuscar={true}
                                />
                            </div>
                        </Tab>
                    )}
                    { dataAprovacaoCP && dataAprovacaoCP.length > 0 && (
                        <Tab key={"CP"} eventKey={"CP"} title={`Contrato de Parceria - ${dataAprovacaoCP.length}`}>
                            <div className="tab-content">
                                <TrelloBoard
                                    columnsFilter={columnsFilter}
                                    AbreBox={DisparaBootBox}
                                    FechaBox={FechaBootBox}
                                    columns={columnsAprovacaoCP}                                    
                                    columnsAditional={columnsDetalheCP}
                                    data={dataAprovacaoCP}
                                    setData={setDataAprovacaoCP}
                                    titleLista={`Contrato de Parceria`}
                                    mdColCard={4}
                                    exibeList={false}
                                    mdColCardOpen={12}
                                    tamanhoCard='80lvh'
                                    HabilitaSelecao={true}
                                    buttons= { 
                                            [   {action: handleFilaItem, label: "Fila", icone: "FaListCheck", style: "outline-info"},
                                                {action: handleAprovarItem, label: "Aprovar", icone: "AiOutlineLike", style: "outline-success"},
                                                {action: handleReprovarItem, label: "Reprovar", icone: "AiOutlineDislike", style: "outline-danger" }
                                            ]
                                    }
                                    handleAprovarTodos={() => handleAprovarTodos('CP')}
                                    handleReprovarTodos={() => handleReprovarTodos('CP')}
                                    HabilitaBuscar={true}
                                />
                            </div>
                        </Tab>
                    )}
                    { dataAprovacaoBM && dataAprovacaoBM.length > 0 && (
                        <Tab key={"BMSI"} eventKey={"BMSI"} title={`BMSI - ${dataAprovacaoBM.length}`}>
                            <div className="tab-content">
                                <TrelloBoard
                                    columnsFilter={columnsFilterBM}
                                    AbreBox={DisparaBootBox}
                                    FechaBox={FechaBootBox}
                                    columns={columnsAprovacaoBM} 
                                    tamanhoCard='85lvh'
                                    data={dataAprovacaoBM} 
                                    setData={setDataAprovacaoBM} 
                                    titleLista={`BMSI`}
                                    columnsAditional={columnsDetalheBM}
                                    mdColCard={4}
                                    exibeList={false}
                                    mdColCardOpen={12}
                                    HabilitaSelecao={true}
                                    buttons= { 
                                            [   {action: handleFilaItem, label: "Fila", icone: "FaListCheck", style: "outline-info"},
                                                {action: handleAprovarItem, label: "Aprovar", icone: "AiOutlineLike", style: "outline-success"},
                                                {action: handleReprovarItem, label: "Reprovar", icone: "AiOutlineDislike", style: "outline-danger" }
                                            ]
                                    }
                                    handleAprovarTodos={() => handleAprovarTodos('BM')}
                                    handleReprovarTodos={(e) => handleReprovarTodos('BM')}
                                    HabilitaBuscar={true}
                                />
                            </div>
                        </Tab>
                    )}
                    {/*
                    <Tab key={"KF"} eventKey={"KF"} title={"KF"}>
                        <div className="tab-content">
                            { dataAprovacao && dataAprovacao.length > 0 &&
                                <TrelloBoard
                                    AbreBox={DisparaBootBox}
                                    FechaBox={FechaBootBox}
                                    columns={columnsAprovacao} 
                                    data={dataAprovacao} 
                                    setData={setDataAprovacao} 
                                    titleLista="Aprovação KF"
                                    buttons= { 
                                            [   {action: handleAprovarItem, label: "Aprovar", icone: "AiOutlineLike", style: "outline-success"},
                                                {action: handleReprovarItem, label: "Reprovar", icone: "AiOutlineDislike", style: "outline-danger" }
                                            ]
                                    }
                                />
                            }
                        </div>
                    </Tab>
                     */}
                </Tabs>
                <ButtonRefresh variant="link" size="sm" onClick={listaAprovacoes}>
                    Atualizar <BiRefresh />
                </ButtonRefresh>
            </div>
        </>
    )
}

export default Aprovacoes;
